/**
 * 年月日格式化，年月日小时分钟秒 截取为年月日
 * @param value
 * @returns {string|*}
 */
export const splitDate = value => {
    if(value){
        return value.substring(0, 10);
    }
    return value;
};